export default __webpack_public_path__ + "static/media/Pioneer.f3deae9d.svg";